'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    MESSAGE: 'message',
    SCRIBBLE_INITIALIZED: 'SCRIBBLE.INITIALIZED',
    BETSLIP_INITIALIZED: 'BETSLIP.INITIALIZED',
    BETSLIP_BOOKMAKER_GET: 'BETSLIP.BOOKMAKER.GET',
    BETSLIP_BOOKMAKER: 'BETSLIP.BOOKMAKER',
    BETSLIP_BOOKMAKER_CHANGED: 'BETSLIP.BOOKMAKER_CHANGED',
    BETSLIP_MAKE_SELECTION: 'BETSLIP.MAKE_SELECTION'
};


//////////////////
// WEBPACK FOOTER
// ./public/js/scribble/constants/EVENTS.js
// module id = 1744
// module chunks = 0